import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './SelectResourceModal.module.scss'

export const SelectResourceModal = ({
  alert,
  className = undefined,
  message,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <Modal
    className={cx(styles.modal, { [className]: Boolean(className) })}
    cancelLabel={t`Cancel`}
    confirmLabel={t`Confirm`}
    {...{ title, onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        message={alert}
        variant="warning"
        isInitialised
      />
      <p className={styles.text}>{message}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
